//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'step5'
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/component/step5.vue